/**
 * See https://react-spectrum.adobe.com/react-aria/routing.html#nextjs
 *
 * tl;dr: Some RAC components are set up to handle routing (e.g. MenuItem).  They
 * use hard routing by default.  In order to integrate client side routing, (next routing)
 * the router is passed through the RAC RouterProvider (because RAC does everything
 * through context which is great.  it's great.  it's fine.  whatever)
 *
 * I can't imagine a place where we wouldn't want to have this available as an
 * option so I'm throwing it in alongside our other top level providers.
 */

"use client";

import {FCWithChildren} from "@/app/types/reactTypes";
import {useRouter} from "next/navigation";
import {RouterProvider} from "react-aria-components";

declare module "react-aria-components" {
	export interface RouterConfig {
		routerOptions: NonNullable<
			Parameters<ReturnType<typeof useRouter>["push"]>[1]
		>;
	}
}

const RACRouterProvider: FCWithChildren = ({children}) => {
	const router = useRouter();

	return <RouterProvider navigate={router.push}>{children}</RouterProvider>;
};

export default RACRouterProvider;
